export const SET_PRODUCT_DETAILS_TAB = 'SET_PRODUCT_DETAILS_TAB'
